<main>
        <div class="contenedor">
            <!-- Header del proyecto -->
            <section class="header-proyecto">
                <div class="imagen-proyecto" style="background-image: url('https://res.cloudinary.com/dg7wvqxcv/image/upload/v1766896697/Gemini_Generated_Image_k7zr9pk7zr9pk7zr-processed_vm1vje.png');"></div>
                <div class="titulo-con-flecha">
                    <a routerLink="/portafolio" class="btn-regreso">
                        <img src="assets/svg/flecha.svg" alt="Regresar">
                    </a>
                    <h1 class="titulo-proyecto">Planta de Tratamiento de Agua Potable de Huachipa - SEDAPAL</h1>
                </div>
                <div class="cuadro_ubicacion">
                    <div class="ubicacion-proyecto">
                    <span class="icono-ubicacion"><img src="assets/svg/IconoMap.svg" alt=""></span>
                        Lima Metropolitana
                    </div>
                </div>
                
            </section>

            <!-- Sección de información del proyecto -->
            <section class="seccion-info-proyecto">
                <div class="grid-info">
                    <div class="info-columna">
                        <h3>Importancia</h3>
                        <p>Una de las plantas más grandes del Perú, con capacidad para abastecer de agua potable a más de 2.4 millones de personas. Es una infraestructura clave para reducir el déficit hídrico en Lima y garantizar el acceso al agua en distritos vulnerables.</p>
                    </div>
                    <div class="separador-vertical"></div>
                    <div class="info-columna">
                        <h3>Descripción del proyecto</h3>
                        <p>Una de las plantas más grandes del Perú, con capacidad para abastecer de agua potable a más de 2.4 millones de personas. Es una infraestructura clave para reducir el déficit hídrico en Lima y garantizar el acceso al agua en distritos vulnerables.</p>
                    </div>
                </div>
            </section>

            <!-- Sección de participación -->
            <section class="seccion-participacion">
                <div class="contenido-participacion">
                    <div class="circulo-azul-decorativo"></div>
                    <div class="info-participacion">
                        <h2>Participación de Corporación Rehobot</h2>
                        <p>Se ejecutó la <strong>construcción de fuentes propias para el abastecimiento del recurso hídrico subterráneo</strong> requeridas durante la etapa de ejecución de la obra y para el funcionamiento posterior de la Planta de Tratamiento Huachipa.</p>
                    </div>
                    <div class="imagen-participacion"></div>
                </div>
            </section>

            <!-- Sección de actividades -->
            <section class="seccion-actividades">
                <h2 class="actividades-titulo">Actividades <span>desarrolladas.</span></h2>
                <div class="contenido-actividades">
                    <div class="tarjeta-actividad">
                    </div>
                    <div class="tarjeta-lista-actividades">
                        <ul class="lista-actividades">
                            <li><strong>Perforación de dos pozos tubulares</strong> y la instalación de sus respectivos sistemas de bombeo.</li>
                            <li><strong>Perforación y equipamiento de un pozo adicional</strong> en el túnel de transvase.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <!-- Sección Más proyectos -->
            <section class="seccion-mas-proyectos">
              <div class="divisor-linea"></div>
              <h2 class="mas-proyectos-titulo">Más <span>proyectos.</span></h2>

              <div class="grid-mas-proyectos">
                <div class="tarjeta-obra-mini" *ngFor="let obra of proyectosRecomendados">
                  <div class="imagen-obra-mini"
                       [style.backgroundImage]="'url(' + obra.imagen + ')'">
                  </div>
                  <div class="contenido-mini">
                    <h3>{{ obra.titulo }}</h3>
                    <a [routerLink]="obra.link" class="btn-conoce-mas">Conoce más</a>
                  </div>
                </div>
              </div>
            </section>
        </div>
    </main>